/**
 * The "Add to project ›" / "Remove from <project>" menu rows for any item
 * (project scope slices 3–5), as ContextMenu items, pure:
 *
 *   - under a project that contains the item: "Remove from <project>"
 *   - otherwise: "Add to project ›" with the projects the item may join (a
 *     personal item → personal projects; a team item → that team's projects)
 *     and is not in yet; no row when there are none
 *
 * `onAdd(project)` / `onRemove(project)` do the write (scope/projectItems).
 */
const teamOf = (project) => {
  const key = String(project?.scopeKey || '');
  return key.startsWith('team:') ? key.slice('team:'.length) : null;
};

/** Projects an item in `wireScope` ('personal' | 'team:<id>' | 'device') may join. */
export function projectsForScope(wireScope, projects = []) {
  const team = String(wireScope || '').startsWith('team:') ? String(wireScope).slice('team:'.length) : null;
  return (projects || []).filter((p) => (team ? teamOf(p) === team : teamOf(p) == null));
}

export function projectMenuRows({ nodeId, wireScope = 'personal', activeProject = null, memberIds = new Set(), projects = [], links = [], labels = {}, icons = {}, onAdd, onRemove }) {
  const L = { add: 'Add to project', remove: (name) => `Remove from ${name}`, ...labels };
  if (activeProject && memberIds.has(nodeId)) {
    return [{ key: 'project-remove', icon: icons.remove, label: L.remove(activeProject.name), onClick: () => onRemove(activeProject) }];
  }
  const already = new Set(
    (links || []).filter((l) => l && l.rel === 'contains' && String(l.to) === nodeId).map((l) => String(l.from).replace(/^project:/, ''))
  );
  const targets = projectsForScope(wireScope, projects).filter((p) => !already.has(String(p.id)));
  if (!targets.length) return [];
  return [{ key: 'project-add', icon: icons.add, label: L.add, items: targets.map((p) => ({ key: `p-${p.id}`, label: p.name, onClick: () => onAdd(p) })) }];
}
